import { useNavigate } from "react-router-dom";

import { SERVICE_TEMPLATE_ID } from "../../../consts/serviceTemplate";

import CommonButton from "../../Button";
import CommonPopup from "..";

type Props = {
  popup: string;
  onClose?: () => void;
  nickname?: string;
};

export default function HotColdVoteReportPopup({
  popup,
  onClose,
  nickname = "",
}: Props) {
  const navigate = useNavigate();

  return (
    <CommonPopup isOpen={popup === "report"} onClose={onClose} padding={0}>
      <div className="flex flex-col gap-2 p-7 leading-[30px]">
        <div className="whitespace-pre-line text-xl font-medium break-keep">
          {`${nickname} 님!`}
          {`\n지금은 투표 개설이 불가능합니다.\n"도와주세요" 서비스로 이동하시겠습니까?`}
          <span className="flex text-brand-neutral-60 text-sm">
            * 18시 이후, 주말, 공휴일은 투표 개설 불가
          </span>
        </div>
      </div>

      <div className="flex">
        <CommonButton
          variant="secondary"
          className="rounded-none flex-1 h-bottom-button"
          onClick={onClose}
        >
          취소
        </CommonButton>
        <CommonButton
          className="rounded-none flex-1 h-bottom-button w-full"
          onClick={() =>
            navigate("/report", {
              state: {
                serviceTemplateId: SERVICE_TEMPLATE_ID.OFF_WORK_HOT_COLD,
              },
            })
          }
        >
          이동
        </CommonButton>
      </div>
    </CommonPopup>
  );
}
